import React from 'react';
import AdminOtp from './AdminOtp';
const OtpCOnfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
				toolbar: {
					display: false,
				},
				footer: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: '/otp',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AdminOtp />
				</React.Suspense>
			),
		},
	],
};

export default OtpCOnfig;
